import React, {useContext, useEffect, useState} from 'react';

import {ZoneSwitcherProps} from "./ZoneSwitcher.props";
import './ZoneSwitcher.style.css';
import {GlobalContext} from "../../../context/GlobalState";

import { TreeDropDown} from "../../molecules/TreeDropDown";
import { ADMIN_ROLE } from "../../../constants/contants";
import { isAdmin } from "../../../utils/common";

function findById(array:any, id:any) {
  for (const item of array) {
    if (item.id.toString() === id.toString()) return item;
    /* istanbul ignore next */
    if (item.children?.length) {
      const innerResult:any = findById(item.children, id);
      if (innerResult) return innerResult;
    }
  }
}

export  const ZoneSwitcher: React.FC<ZoneSwitcherProps> = ({/* istanbul ignore next */dataSource=[], ...props}) => {
    const [dataList, setDataList] = useState<any[]>([])
    const [masterNode, setMasterNode] = useState<any>({})
    const rawDataSource = dataSource;
    let currentZone  = sessionStorage.getItem('currentZone') || localStorage.getItem('currentZone') || ''
    let { globalDispatch, reloadDispatcher } = useContext(GlobalContext);

    useEffect(() => {
      setDataList(rawDataSource)
      let currentMaster = findById(rawDataSource, parseInt(currentZone))
      if (currentMaster) {
        setMasterNode({id: currentMaster.id, name: currentMaster.name, path: currentMaster.path, ms365: currentMaster.ms365})
      } else {
        /* istanbul ignore next */
        setMasterNode({id: rawDataSource[0]?.id, name: rawDataSource[0]?.name, path: rawDataSource[0]?.path, ms365: rawDataSource[0]?.ms365})
      }
    }, [dataSource]);

    const onItemClick = (node:any):void => {
      setMasterNode({id: node.id, name: node.name, path: node.path, ca: node.ca, ms365: node.ms365})
          globalDispatch({
            type: 'UPDATE_SELECTED_ZONE_ID',
            payload: node.id
          })
            globalDispatch({
                type: 'UPDATE_SELECTED_ZONE_CA',
                payload: node.id
            })
            globalDispatch({
                type: 'UPDATE_MS365_CURRENT_ZONE',
                payload: node.ms365
            })
            globalDispatch({
                type: 'UPDATE_GLOBAL_ZONE',
                payload: node.global_zone == true
            })
          localStorage.setItem('currentZone', node.id)
          sessionStorage.setItem('currentZone', node.id)
          localStorage.setItem('globalZone', node.global_zone)
          sessionStorage.setItem('globalZone', node.global_zone)
          localStorage.setItem('isMS365', node.ms365)
          sessionStorage.setItem('isMS365', node.ms365)
          localStorage.setItem('startZoneDate', node.ca)
           sessionStorage.setItem('startZoneDate', node.ca)
          localStorage.setItem('fromChangeNode', "1")
          sessionStorage.setItem('fromChangeNode', "1")
          reloadDispatcher(node.id)
    }
    return (
      <div className="zone-tree-wrapper">
        {/*<CustomDropDown index={1} masterNode={masterNode} dataSource={dataList} onItemClick={onItemClick} />*/}
     <TreeDropDown masterNode={masterNode} dataSource={dataList} onItemClick={onItemClick}/>
      </div>
    );
};
